import produce from 'immer';

import { FETCH_EVENTS_PENDING, FETCH_EVENTS_FULFILLED, FETCH_EVENTS_FAILED } from '../constants/actions/eventActions';

const initialState = {
	loading: false,
	error: false,
	eventsMapper: {},
	pageSize: 20,
	totalItems: 0,
	totalPages: 1,
};

const eventReducer = produce((draft, action: any) => {
	switch (action.type) {
		case FETCH_EVENTS_PENDING: {
			draft.loading = true;
			break;
		}
		case FETCH_EVENTS_FULFILLED: {
			draft.loading = false;
			draft.eventsMapper[action.payload.events.Page] = action.payload.events.Items;
			draft.pageSize = action.payload.events.PageSize;
			draft.totalItems = action.payload.events.TotalItems;
			draft.totalPages = action.payload.events.TotalPages;
			break;
		}
		case FETCH_EVENTS_FAILED: {
			draft.loading = false;
			draft.error = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialState);

export default eventReducer;
